import React from 'react';
import {ProgressSpinner} from 'primereact/progressspinner';
import {classNames} from 'primereact/utils';
import './Loader.scss';

interface LoaderProps {
  size?: 'small' | 'normal' | 'large';
  overlay?: boolean;
  message?: string;
  className?: string;
}

const Loader: React.FC<LoaderProps> = ({size = 'normal', overlay = false, message, className}) => {
  const loaderClass = classNames(
    'custom-loader',
    `custom-loader--${size}`,
    {
      'custom-loader--overlay': overlay,
    },
    className,
  );

  const spinnerSize = size === 'small' ? '2rem' : size === 'large' ? '4rem' : '3rem';

  return (
    <div className={loaderClass}>
      <div className="custom-loader__content">
        <ProgressSpinner style={{width: spinnerSize, height: spinnerSize}} strokeWidth="4" animationDuration="1s" />
        {message && <p className="custom-loader__message">{message}</p>}
      </div>
    </div>
  );
};

export default Loader;
